import { useLocation } from 'react-router';

import styles from '@components/menus/MenuItem.module.css';
import MenuItemText from '@components/menus/MenuItemText';
import Icon from '@components/text/Icon';
import InternalLink from '@components/typography/InternalLink';
import { IconName } from '@utils/iconUtils';

type MenuItemProps = {
  iconName: IconName;
  onClick?: () => void;
  text: string;
  to: string;
  unread?: boolean;
};

const MenuItem = ({ iconName, onClick, text, to, unread = false }: MenuItemProps) => {
  const location = useLocation();

  const selected = location.pathname.includes(to.split('?')[0]);

  return (
    <div className={`${styles.menuItem} ${selected ? styles.selectedMenuItem : ''}`} data-test="nav-item">
      <InternalLink expand onClick={onClick} stylized={false} to={to}>
        <div className={selected ? styles.selectedLink : styles.notSelectedLink}>
          <MenuItemText icon={iconName} text={text} />
          {unread && <Icon color="danger-300" icon="circleExclamation" spacingStart />}
        </div>
      </InternalLink>
    </div>
  );
};

export default MenuItem;
